export const getMessageBackgroundColor = (
  isFromMe: boolean,
  service?: string
): string => {
  if (!isFromMe) {
    return '#eef0fa' // Incoming messages stay the same
  }

  // Outgoing messages: iMessage = blue, everything else (SMS, etc.) = green
  return service === 'iMessage' ? '#007bff' : '#65c466'
}
